"use strict";
(globalThis["webpackChunktvg_shopify_theme"] ||= []).push([[83],{

/***/ 341
(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* unused harmony export default */
/* harmony import */ var _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7809);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(544);
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(405);
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(140);




class VideoCarouselController extends _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__.Controller {
  static targets = ['swiper', 'video', 'playButton', 'prevButton', 'nextButton', 'productCard']
  
  connect() {
    this.initSwiper()
  }

  disconnect() {
    this.swiper?.destroy()
    this.swiper = null
  }

  initSwiper() {
    this.swiper = new swiper__WEBPACK_IMPORTED_MODULE_1__["default"](this.swiperTarget, {
      modules: [swiper_modules__WEBPACK_IMPORTED_MODULE_2__["default"], swiper_modules__WEBPACK_IMPORTED_MODULE_3__["default"]],
      direction: 'horizontal',
      slidesPerView: 2.2,
      breakpoints: {
        768: {
          slidesPerView: 3.2,
        },
        1024: {
          slidesPerView: 4.2,
        },
        1200: {
          slidesPerView: 5.2,
        },
      },
      spaceBetween: 12,
      autoplay: {
        delay: 4000,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: this.nextButtonTarget,
        prevEl: this.prevButtonTarget,
        disabledClass: 'opacity-40',
      },
    })

    this.swiper.on('slideChangeTransitionStart', () => {
      this.muteAllVideos()
      this.showAllPlayButtons()
    })

    this.swiper.on('slideChangeTransitionEnd', () => {
      this.playActiveSlideVideo()
    })

    this.playActiveSlideVideo()
  }

  stopVideo(event) {
    const video = event.currentTarget
    if (video.paused || video.muted) return

    video.muted = true
    video.pause()
    if (video.poster) {
      video.load()
    } else {
      video.currentTime = 0.5
    }
    const slide = video.closest('.swiper-slide')
    const playButton = this.playButtonTargets.find(btn => slide?.contains(btn))
    playButton?.classList.remove('opacity-0', 'pointer-events-none')
    playButton?.setAttribute('aria-label', 'Play video')
    const productCard = this.productCardTargets.find(card => slide?.contains(card))
    productCard?.classList.add('hidden')
    this.swiper?.autoplay?.start()
  }

  togglePlay(event) {
    const button = event.currentTarget
    const slide = button.closest('.swiper-slide')
    const video = this.videoTargets.find(v => slide?.contains(v))
    if (!video) return

    const productCard = this.productCardTargets.find(card => slide?.contains(card))

    if (!video.muted && !video.paused) {
      video.muted = true
      video.pause()
      if (video.poster) {
        video.load()
      } else {
        video.currentTime = 0.5
      }
      button.classList.remove('opacity-0', 'pointer-events-none')
      button.setAttribute('aria-label', 'Play video')
      productCard?.classList.add('hidden')
      this.swiper.autoplay.start()
    } else {
      this.muteAllVideos()
      this.showAllPlayButtons()
      video.muted = false
      video.play().catch(() => {})
      button.classList.add('opacity-0', 'pointer-events-none')
      button.setAttribute('aria-label', 'Pause video')
      productCard?.classList.remove('hidden')
      this.swiper.autoplay.stop()
    }
  }

  playActiveSlideVideo() {
    const activeSlide = this.swiperTarget.querySelector('.swiper-slide-active')
    if (!activeSlide) return
    const video = this.videoTargets.find(v => activeSlide.contains(v))
    if (!video) return
    video.play().catch(() => {})
  }

  muteAllVideos() {
    this.videoTargets.forEach(v => {
      v.pause()
      v.muted = true
      if (v.poster) {
        v.load()
      } else {
        v.currentTime = 0.5
      }
    })
  }

  showAllPlayButtons() {
    this.playButtonTargets.forEach(btn => {
      btn.classList.remove('opacity-0', 'pointer-events-none')
      btn.setAttribute('aria-label', 'Play video')
    })
    this.productCardTargets.forEach(card => card.classList.add('hidden'))
  }
}

Stimulus.register('video-carousel', VideoCarouselController)


/***/ }

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(341)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);